import { createTextInputAdder } from './createTextInputAdder'

export const addComponentForTextField =
  createTextInputAdder('textFieldTemplate')
